/*
* This code is the intellectual property of Bulb Inc. and other software publishers;
* it may not be altered, copied or disclosed without prior written approval.
* Copyright 2022, Bulb Inc. For more information, please email contact@hellobulb.com.
*/

import {
  Directive,
  OnChanges,
  Input,
  ElementRef,
  SimpleChanges,
} from '@angular/core';
import { AnimationBuilder, AnimationPlayer } from '@angular/animations';
import { BulbAnimations } from '../animations';

@Directive({
  selector: '[bulbAnimations]',
  standalone: false,
})

export class AnimationsDirective implements OnChanges {

  private animationPlayer: AnimationPlayer;

  @Input() animationTrigger: boolean | number;

  @Input() elementAnimations: string;

  constructor(private builder: AnimationBuilder, private el: ElementRef) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.animationTrigger.currentValue || changes.animationTrigger.currentValue === 0) {
      this.animate();
    }
  }

  private createFactory(animation: string) {
    const metaData = BulbAnimations[animation];
    const factory = this.builder.build(metaData);
    this.animationPlayer = factory.create(this.el.nativeElement);
    this.animationPlayer.play();
  }

  private animate() {
    if (this.elementAnimations && this.elementAnimations !== '') {
      if (this.animationPlayer) {
        this.animationPlayer.destroy();
      }
      if (BulbAnimations[this.elementAnimations]) {
        this.createFactory(this.elementAnimations);
      } else {
        throw new Error(`Invalid Animation Passed In ${this.elementAnimations}`);
      }
    }
  }
}
